import React from 'react'
import { Container } from './styles'

const FullScreenWrapper = ({ children }) => {
	return <Container>{children}</Container>
}

export default FullScreenWrapper
